import React, { useState, Component, Fragment } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import axios from "../../security/axios";
import { useAcceptJs } from "react-acceptjs";
import "./OrderManager.css";
import NotificationBar from "../../components/notification-bar/NotificationBar";
import CreateNewOrder from "./manager/CreateNewOrder";
import ManageOrder from "./manager/ManageOrder";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";
import { CUSTOMER_MANAGER_TA_CONTACT_UPDATE, CUSTOMER_MANAGER_TA_PRODUCT_SWAP, CUSTOMER_MANAGER_TA_ORDER_MANAGEMENT, hasRole } from "../../security/auth";


const OrderManager = () => {
    const routes = ['/order-manager/create-order-1', '/order-manager/create-order-2', '/order-manager/manage-order'];
    return (
        <BrowserRouter>
            <Route
                path="/order-manager"
                render={({ location }) => (
                    <Fragment>
                        <AppBar position="static">
                            <Tabs value={location.pathname}>
                                <Tab label="Create Order Merchant 1" value="/order-manager/create-order-1" component={Link} to={routes[0]} />
                                <Tab label="Create Order MErchant 2" value="/order-manager/create-order-2" component={Link} to={routes[1]} />
                                <Tab label="Manage Order" value="/order-manager/manage-order" component={Link} to={routes[2]} />
                            </Tabs>
                        </AppBar>
                        <Switch>
                            <Route path={routes[0]} exact render={() => hasRole(CUSTOMER_MANAGER_TA_ORDER_MANAGEMENT) ? <CreateNewOrder merchant={1} /> : <CreateNewOrder merchant={1}/>} />
                            <Route path={routes[1]} exact render={() => hasRole(CUSTOMER_MANAGER_TA_ORDER_MANAGEMENT) ? <CreateNewOrder merchant={2}/> : <CreateNewOrder merchant={2}/>} />
                            <Route path={routes[2]} exact render={() => hasRole(CUSTOMER_MANAGER_TA_ORDER_MANAGEMENT) ? <ManageOrder /> : <ManageOrder />} />
                        </Switch>
                    </Fragment>
                )}
            />
        </BrowserRouter>
    );
};


export default OrderManager;